import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment-system.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment-system.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/system/payment-system.vue?vue&type=script&lang=js
// module id = Jmd5
// module chunks = 0